import theme from "@/theme";

export const styles = {
  dropdown: {
    position: "absolute" as const,
    zIndex: 9000,
    width: 286,
    background: "#FFFFFF",
    borderRadius: 8,
    padding: 8,
    boxShadow: "0px 0px 16px 0px #0000001A",
    overflowY: "auto" as const,
    maxHeight: 256,
  },
  item: {
    width: 270,
    height: 60,
    borderRadius: 8,
    padding: 8,
    gap: 4,
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    cursor: "pointer",
  },
  name: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    color: theme.palette.custom.mainBlue,
  },
  codeType: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: "20px",
    color: theme.palette.custom.mainBlue,
  },
  codeTypeHighlighted: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    color: "#D0021B",
  },
};
